












































































































































































































































































import Vue from 'vue'
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxColumnChooser,
  DxSorting,
  DxFilterRow,
  DxGroupPanel, DxGrouping, DxStateStoring
} from 'devextreme-vue/data-grid'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import ProjectPartsListDetailDialog from '@/components/project/ProjectPartsListDetailDialog.vue'
import { Pane, Splitpanes } from 'splitpanes'
import ProductTextLanguagesDialog from '@/components/master-data/product/ProductTextLanguagesDialog.vue'
import { UiLanguageItem, UiLanguageList } from '@/types'
import { hexToRgba } from '@/services/hex-to-rgba'
import ProductSearch from '@/components/project/ProductSearch.vue'
import { ProductSearchResult } from '@/model/project/ProductSearchResult'
import { FETCH_PROJECT_DETAIL_PARTS_LIST_DATA } from '@/store/action-types'
import { SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { ProjectDetail } from '@/model/project/ProjectDetail'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  showDetailDialog: boolean
  pane1Size: number
  pane2Size: number
  pane2Width: number
  isSplitterOpen: boolean
  activeTab: number
  isEdit: boolean
  formIsValid: boolean
  isSaveInProgress: boolean
  showSearchDialog: boolean
  searchString: string
  selectedProduct: ProductSearchResult | null

  gridData: any[]
  selectedRowIndex: number
  selectedRow: any | null

  selectedArt: any
  artList: any[]
  text: string | null
  text2: string | null
  showLanguages1Dialog: boolean
  showLanguages2Dialog: boolean
  languages1: any[]
  languages2: any[]
}

export default Vue.extend({
  name: 'ProjectPartsList',

  components: {
    ProgressCircular,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxStateStoring,
    Splitpanes,
    Pane,
    ProjectPartsListDetailDialog,
    ProductTextLanguagesDialog,
    ProductSearch
  },

  props: {
    height: String,
    projectDetail: Object as () => ProjectDetail || null,
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      showDetailDialog: false,
      pane1Size: 100,
      pane2Size: 0,
      pane2Width: 50,
      isSplitterOpen: false,
      activeTab: 1,
      isEdit: false,
      formIsValid: false,
      isSaveInProgress: false,
      showSearchDialog: false,
      searchString: '',
      selectedProduct: null,

      gridData: [],
      selectedRowIndex: 0,
      selectedRow: null,

      selectedArt: null,
      artList:  [{id: 1, label: 'Art 1'}, {id: 2, label: 'Art 2'}],
      text: null,
      text2: null,
      showLanguages1Dialog: false,
      showLanguages2Dialog: false,
      languages1: [],
      languages2: [],
    }
  },

  watch: {

  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    isBeforeDisabled (): boolean {
      return this.selectedRowIndex === 0
    },

    isAfterDisabled (): boolean {
      return this.selectedRowIndex === this.gridData.length -1
    },

    isDisabledInsertButton (): boolean {
      return false
    },

    isDisabledUpdateButton (): boolean {
      return false
    },

    isDisabledDeleteButton (): boolean {
      return false
    },

    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onCreateClick (): void {
      this.activeTab = 1
      this.showSearchDialog = true
    },

    onSelectedProduct (data: ProductSearchResult): void {
      this.showSearchDialog = false
      this.selectedProduct = data
      this.isEdit = true
      this.$nextTick(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      })
    },

    closeSearchDialog (): void {
      this.showSearchDialog = false
    },

    onUpdateClick (): void {
      this.activeTab = 1
      this.isEdit = true
      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 100)
    },

    onDeleteClick (): void {

    },

    onBeforeClick (): void {
      this.isEdit = false
      this.selectedRowIndex -= 1
      this.selectedRow = this.gridData[this.selectedRowIndex]
      //@ts-ignore
      this.$refs.dataGrid.instance.selectRows([this.gridData[this.selectedRowIndex].id])
    },

    onAfterClick (): void {
      this.isEdit = false
      this.selectedRowIndex += 1
      this.selectedRow = this.gridData[this.selectedRowIndex]
      //@ts-ignore
      this.$refs.dataGrid.instance.selectRows([this.gridData[this.selectedRowIndex].id])
    },

    onCopyClick (): void {

    },

    onSaveButtonClick (): void {
      this.isEdit = false
      const form: any = this.$refs['form']
      if(this.formIsValid && form.validate()) {

      }
    },

    onCancelClick (): void {
      this.isEdit = false
    },

    splitterDoubleClick (e: any): void {
      if(this.isSplitterOpen) {
        setTimeout(() => {
          this.resizePane()
        }, 0)
      } else {
        setTimeout(() => {
          this.pane1Size = 100
          this.pane2Size = 0
        }, 0)
      }

      this.isSplitterOpen = !this.isSplitterOpen
    },

    resizePane (): void {
      this.pane2Size = this.pane2Width
      this.pane1Size = 100 - this.pane2Size
    },

    addMenuItems(e: any) {
      if (e.target == 'content') {
        // e.items can be undefined
        if (!e.items) e.items = []

        // Add a custom menu item
        e.items.push({
          text: this.$t('project.projectPartsList.contextMenu1').toString(),
          onItemClick: () => {
            console.log(e.row.data.id)
            this.showDetailDialog = true
          }
        })
      }
    },

    onDetailDialogClose (): void {
      this.showDetailDialog = false
    },

    onRowClick (data: any): void {
      const foundRow: any | undefined = this.gridData.find((item: any) => item.id === data.data.id)
      if(foundRow) {
        this.selectedRowIndex = this.gridData.indexOf(foundRow)
        this.selectedRow = foundRow
      }
    },

    onArtChange (): void {

    },

    onLanguages1Click (): void {
      this.showLanguages1Dialog = true
    },

    onLanguages1DialogSave (): void {
      this.showLanguages1Dialog = false
    },

    onLanguages1DialogClose (): void {
      this.showLanguages1Dialog = false
    },

    onLanguages2Click (): void {
      this.showLanguages2Dialog = true
    },

    onLanguages2DialogSave (): void {
      this.showLanguages2Dialog = false
    },

    onLanguages2DialogClose (): void {
      this.showLanguages2Dialog = false
    },

    async fetchData (): Promise<void> {
      try {
        this.loading = true
        const response: any = await this.$store.dispatch(FETCH_PROJECT_DETAIL_PARTS_LIST_DATA, this.projectDetail!.ID)
        this.loading = false
        if (!response.IsError && response.Data) {
          this.gridData = response.Data

          if(this.gridData.length > 0) {
            this.selectedRow = this.gridData[this.selectedRowIndex]
            //@ts-ignore
            setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.selectedRow.id])}, 0)
          }

        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    fetchData2 (): void {
      this.gridData = [
        {id: 1, value1: '1', value2: '72047 - Meiller Rolltor'},
        {id: 2, value1: '2', value2: '72047 - Meiller Rolltor'},
        {id: 3, value1: '3', value2: '72047 - Meiller Rolltor'},
        {id: 4, value1: '4', value2: '72047 - Meiller Rolltor'},
        {id: 5, value1: '5', value2: '72011 - Siepe VKT'},
        {id: 6, value1: '6', value2: '72011 - Siepe VKT'},
        {id: 7, value1: '7', value2: '72011 - Siepe VKT'},
      ]

      if(this.gridData.length > 0) {
        this.selectedRow = this.gridData[this.selectedRowIndex]
        //@ts-ignore
        setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.selectedRow.id])}, 0)
      }
    },

    onResize (): void {
      setTimeout(() => {
        const splitpanes: any = this.$refs['splitpanes']
        this.pane2Width =  splitpanes ? (465 / splitpanes.$el.clientWidth) * 100 : 50
        this.resizePane()
      }, 0)
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  mounted () {
    const splitter = document.getElementsByClassName("parts_list")[0]
    if(splitter) {
      splitter!.addEventListener("dblclick", this.splitterDoubleClick)
    }

    if(this.projectDetail) {
      this.fetchData()
    }

    this.languages1 = this.uiLanguageList.map((item: UiLanguageItem) => {
      return {
        languageId: item.syzId,
        text : ''
      }
    })

    this.languages2 = this.uiLanguageList.map((item: UiLanguageItem) => {
      return {
        languageId: item.syzId,
        text : ''
      }
    })
  },

  beforeDestroy (): void {
    const splitter = document.getElementsByClassName("splitpanes__splitter")[0]
    if(splitter) {
      splitter.removeEventListener("dblclick", this.splitterDoubleClick)
    }
  }
})
